var map = {
	"./双子座.jpg": 3005,
	"./双鱼座.jpg": 9153,
	"./处女座.jpg": 7872,
	"./天秤座.jpg": 8992,
	"./天蝎座.jpg": 9942,
	"./射手座.jpg": 5512,
	"./巨蟹座.jpg": 2162,
	"./摩羯座.jpg": 3965,
	"./水瓶座.jpg": 267,
	"./狮子座.jpg": 255,
	"./白羊座.jpg": 9006,
	"./金牛座.jpg": 2625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2259;